export const enum RecaptchaAction {
    CheckoutChargeToken = 'checkout_chargetoken'
}
